// useAskPrice.js
import React, { useState, useCallback } from "react";
import './prompt-modal.css'; // Import the shared CSS
import ButtonBasic from "../buttonBasic/view";

// Componente interno Modal
function PriceModal({ isOpen, defaultValue, onConfirm, onCancel }) {
  const [value, setValue] = useState(defaultValue ?? "");

  // Si el defaultValue cambia cuando reabre el modal, actualizarlo
  React.useEffect(() => {
    if (isOpen) {
      setValue(defaultValue ?? "");
    }
  }, [isOpen, defaultValue]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(parseFloat(value));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleConfirm();
    } else if (e.key === "Escape") {
      e.preventDefault();
      onCancel();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content-prompt">
        <label>
          Precio:
          <input
            type="number"
            step="0.01"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </label>
        <div className="button-group-prompt"> 
          <ButtonBasic className='buttonCancel' onClick={onCancel}>Cancelar</ButtonBasic>
          <ButtonBasic onClick={handleConfirm}>Aceptar</ButtonBasic> 
        </div>
      </div>
    </div>
  );
}

export function useAskPrice() {
  const [isOpen, setIsOpen] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");
  const [resolveFn, setResolveFn] = useState(null);
  const [rejectFn, setRejectFn] = useState(null);

  const askPrice = useCallback((value) => {
    return new Promise((resolve, reject) => {
      setDefaultValue(value);
      setResolveFn(() => resolve);
      setRejectFn(() => reject);
      setIsOpen(true);
    });
  }, []);

  const onConfirm = (newValue) => {
    if (resolveFn) resolveFn(newValue);
    cleanup();
  };

  const onCancel = () => {
    if (rejectFn) rejectFn(new Error("cancelled"));
    cleanup();
  };

  const cleanup = () => {
    setIsOpen(false);
    setDefaultValue("");
    setResolveFn(null);
    setRejectFn(null);
  };

  return {
    askPrice,
    PriceModalComponent: (
      <PriceModal
        isOpen={isOpen}
        defaultValue={defaultValue}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    ),
  };
}
